/* eslint-disable no-shadow */
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

export enum OperationType {
  Text,
  Phone,
}

export interface PhoneOperation {
  type: OperationType;
  code: string;
  noPhoneNames: string[];
}

@Component({
  selector: 'app-open-phone-dialog',
  standalone: false,
  templateUrl: './open-phone-dialog.component.html',
  styleUrl: './open-phone-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OpenPhoneDialogComponent {
  OperationType = OperationType;

  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: PhoneOperation,
  ) {}
}
